import React from 'react'
import { Modal, Button, Tabs } from 'antd'
import TargetInfoBox from './TargetInfoBox'
import KnowledgeGraph from '../KnowledgeGraph';
import TwitterStatistics from '../TwitterStatistics';
import {Tweets} from '../Tweets'
import { useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';
// import { useMemo } from 'react';
import { osintRequestAddress } from '../config'

const { TabPane } = Tabs;

const validateArr = (arr) => {
    return Array.isArray(arr) && arr.length > 0
}

const TargetDetails = (props) => {
    const { target, isModalOpen, handleModalShow } = props
    const [validTabs, setValidTabs] = useState([])
    const [wiki, setWiki] = useState({})
    const [kgData, setKgData] = useState([])
    const [infoboxhtml, setInfoboxhtml] = useState('')
    const [targetTweets, setTargetTweets] = useState([])
    const [wordfreq, setWordfreq] = useState([])
    const [trends, setTrends] = useState({})
    const [publicTweets, setPublicTweets] = useState([])

    useEffect(()=>{
        if (target.qcode){
            axios.get(`${osintRequestAddress}/kg?qcode=`+target.qcode).then(
                response => {
                    if (response.data){
                        setWiki(response.data.wikipedia.length>0 ? response.data.wikipedia[0]:{})
                        setKgData(response.data.relatedNodes)
                        if (response.data.relatedNodes && validateArr(response.data.relatedNodes) && !validTabs.includes("关系图谱")){
                            // setValidTabs([...validTabs,"关系图谱"])
                            setValidTabs(tabs=>[...tabs,"关系图谱"])
                        }
                        if (response.data.wikipedia.length>0){
                            const {language, title} = response.data.wikipedia[0]
                            axios.get(`${osintRequestAddress}/wiki/infoboxhtml?lang=${language}&article=${title}`).then(
                                response => {
                                    if (response.data){
                                        setInfoboxhtml(response.data)
                                    }                        
                                },
                                error => {console.log("error",error)}
                            )
                        }
                    }                      
                },
                error => {console.log("error",error)}
            )
        }    
        // 获取最新推文及词频和发帖频率   
        if (target.screenName){
            axios.get(`${osintRequestAddress}/tw?screenName=${target.screenName}&dotrans=true`).then(   //带翻译
                response => {
                    if (response.data && response.data.length>0){
                        setTargetTweets(response.data)
                        if (response.data && validateArr(response.data) && !validTabs.includes("官推言论")){
                            // setValidTabs([...validTabs,"官推言论"])
                            setValidTabs(tabs=>[...tabs,"官推言论"])
                        }
                    }                        
                },
                error => {console.log("error",error)}
            )
            // 获取推文词频和发帖频率                             
            axios.get(`${osintRequestAddress}/tw?screenName=${target.screenName}&wordfreqrange=50`).then(
                response => {
                    if (response.data){     
                        setWordfreq(response.data.wordFrequency)   
                        setTrends(response.data.trends)    
                    }                        
                },
                error => {console.log("error",error)}
            )
        }
        if (target.engName){
            axios.get(`${osintRequestAddress}/tweets?keyword=%23` + target.engName).then(            
                response => {
                    var tweetsSet = new Set();
                    if (response.data){
                        response.data.map((tweet)=>
                            tweetsSet.add(tweet)
                        )                    
                    }
                    if (target.chnName){
                        axios.get(`${osintRequestAddress}/tweets?keyword=` + target.chnName).then(
                            response =>{
                                if (response.data){
                                    response.data.map((tweet)=>
                                        tweetsSet.add(tweet)
                                    ) 
                                }
                                setPublicTweets (Array.from(tweetsSet))
                                if (publicTweets && validateArr(publicTweets) && !validTabs.includes("社媒动态")){
                                    // setValidTabs([...validTabs,"社媒动态"])
                                    setValidTabs(tabs=>[...tabs,"社媒动态"])
                                }                        
                            },
                            error => {console.log("error",error)}
                        )  
                    }
                                                                        
                },
                error => {console.log("error",error)}
            )  
        }
        // console.log(targetTweets);
        console.log("validTabs:", validTabs);
    },[])

    return (
        <Modal title="设施目标" maskClosable={false} width={'70vw'} visible={isModalOpen} onCancel={handleModalShow}
            footer={[<Button key="close" type="primary" onClick={handleModalShow}>关闭</Button>]}>
            <Tabs key={target} defaultActiveKey={999}>
                <TabPane tab="基础资料" key={999} style={{align:'center'}}>
                    <TargetInfoBox target={target} wikiIntro={wiki.content} infoboxhtml={infoboxhtml}/>
                </TabPane>
                {validTabs.map((tab,index) => {
                    switch (tab){
                        case "官推言论":
                            return (
                                <TabPane tab={tab} key={index} style={{align:'center'}}>
                                    <TwitterStatistics screenName={target.screenName} tweets={targetTweets} wordData={wordfreq} trends={trends}/>
                                </TabPane>
                            )
                        case "社媒动态":
                            return (
                                <TabPane tab={tab} key={index} style={{align:'center'}}>
                                    <Tweets tweets={publicTweets}/>
                                </TabPane>
                            )
                        case "关系图谱":
                            return (
                                <TabPane tab={tab} key={index} style={{align:'center'}}>
                                    <KnowledgeGraph kgData={kgData} wikiWord={wiki} />
                                </TabPane>
                            )
                        default:
                            return ''
                    }                        
                })}  
            </Tabs>             
        </Modal>
    )
}

export default TargetDetails